import {
  Badge,
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { useGetDimensionItemUsage } from "../../../hooks/query/dimensions/dimensionAdmin";

const statusColorMap = {
  NEW: "blue",
  IN_PROGRESS: "orange",
  FINALIZED: "green",
};

function DimensionItemUsageModal({ isOpen, onClose, item }) {
  const { data: usage, isLoading } = useGetDimensionItemUsage(item?.id, {
    enabled: isOpen && !!item?.id,
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent maxW="800px">
        <ModalHeader>Usage: {item?.name}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {isLoading ? (
            <Box p={8} textAlign="center">
              <Spinner size="lg" />
            </Box>
          ) : !usage || usage.length === 0 ? (
            <Box p={6} textAlign="center" color="gray.500">
              <Text>This item is not used in any questionnaires.</Text>
            </Box>
          ) : (
            <>
              <Text mb={3} fontSize="sm" color="gray.600">
                Referenced in {usage.length} questionnaire{usage.length !== 1 ? "s" : ""}:
              </Text>
              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th>Questionnaire</Th>
                    <Th>Year</Th>
                    <Th>Assignee</Th>
                    <Th>Status</Th>
                    <Th isNumeric>Scope 1</Th>
                    <Th isNumeric>Scope 2</Th>
                    <Th isNumeric>Scope 3</Th>
                    <Th isNumeric>Water</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {usage.map((entry) => (
                    <Tr key={entry.questionnaireId}>
                      <Td>{entry.name}</Td>
                      <Td>{entry.year}</Td>
                      <Td>{entry.assignee || "-"}</Td>
                      <Td>
                        <Badge colorScheme={statusColorMap[entry.status] || "gray"} fontSize="xs">
                          {entry.status}
                        </Badge>
                      </Td>
                      <Td isNumeric>{entry.scope1Entries}</Td>
                      <Td isNumeric>{entry.scope2Entries}</Td>
                      <Td isNumeric>{entry.scope3Entries}</Td>
                      <Td isNumeric>{entry.waterUsageEntries}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default DimensionItemUsageModal;
